import { render } from "./BadgeDefault.vue?vue&type=template&id=65f0775a"
import script from "./BadgeDefault.vue?vue&type=script&lang=js"
export * from "./BadgeDefault.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__